/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface RecentHotelViewRequest
 */
export interface RecentHotelViewRequest {
    /**
     *
     * @type {number}
     * @memberof RecentHotelViewRequest
     */
    propertyId: number;
    /**
     *
     * @type {string}
     * @memberof RecentHotelViewRequest
     */
    checkin: string;
    /**
     *
     * @type {string}
     * @memberof RecentHotelViewRequest
     */
    checkout: string;
    /**
     *
     * @type {number}
     * @memberof RecentHotelViewRequest
     */
    numberOfAdults: number;
    /**
     *
     * @type {Array<number>}
     * @memberof RecentHotelViewRequest
     */
    childrenAges?: Array<number>;
    /**
     *
     * @type {string}
     * @memberof RecentHotelViewRequest
     */
    searchSessionId?: string;
}

/**
 * Check if a given object implements the RecentHotelViewRequest interface.
 */
export function instanceOfRecentHotelViewRequest(value: object): value is RecentHotelViewRequest {
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('numberOfAdults' in value) || value['numberOfAdults'] === undefined) return false;
    return true;
}

export function RecentHotelViewRequestFromJSON(json: any): RecentHotelViewRequest {
    return RecentHotelViewRequestFromJSONTyped(json, false);
}

export function RecentHotelViewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentHotelViewRequest {
    if (json == null) {
        return json;
    }
    return {

        'propertyId': json['property_id'],
        'checkin': json['checkin'],
        'checkout': json['checkout'],
        'numberOfAdults': json['number_of_adults'],
        'childrenAges': json['children_ages'] == null ? undefined : json['children_ages'],
        'searchSessionId': json['search_session_id'] == null ? undefined : json['search_session_id'],
    };
}

export function RecentHotelViewRequestToJSON(json: any): RecentHotelViewRequest {
    return RecentHotelViewRequestToJSONTyped(json, false);
}

export function RecentHotelViewRequestToJSONTyped(value?: RecentHotelViewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'property_id': value['propertyId'],
        'checkin': value['checkin'],
        'checkout': value['checkout'],
        'number_of_adults': value['numberOfAdults'],
        'children_ages': value['childrenAges'],
        'search_session_id': value['searchSessionId'],
    };
}
